import { useCallback, useEffect, useState } from "react";
import { taskChargesHistoryByPackageIdService } from "../../services/company.service";

export const hasChargeEntries = (entity) =>
  [entity?.postCharges, entity?.invoiceDetails].some((list) => Array.isArray(list) && list.length > 0);

// hasPostedCharges is null until the history for the current package has loaded, or when it cannot be loaded.
export const usePackageChargeHistory = (packageId) => {
  const [result, setResult] = useState({ packageId: null, hasCharges: null });
  const [refreshKey, setRefreshKey] = useState(0);
  const refreshChargeHistory = useCallback(() => setRefreshKey((key) => key + 1), []);

  useEffect(() => {
    const numericId = Number(packageId);
    if (!(numericId > 0)) return undefined;
    let ignore = false;

    const load = async () => {
      try {
        const entity = (await taskChargesHistoryByPackageIdService({ packageId: numericId }))?.data?.Entity;
        if (entity && !ignore) setResult({ packageId: numericId, hasCharges: hasChargeEntries(entity) });
      } catch (error) {
        console.error("Unable to load the package charges history", error);
      }
    };
    void load();

    return () => {
      ignore = true;
    };
  }, [packageId, refreshKey]);

  const hasPostedCharges = result.packageId === Number(packageId) ? result.hasCharges : null;
  return { hasPostedCharges, refreshChargeHistory };
};
